<template>
  <div class="add-content-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="550px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="params" label-width="130px">
        <el-form-item label="任务标题:" prop="title">
          <el-input
            v-model="params.title"
            type="text"
            size="small"
            placeholder="请输入任务标题"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务描述:" prop="desc">
          <el-input
            v-model="params.desc"
            type="textarea"
            size="small"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="请输入任务描述"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务图片:" prop="bgImg">
          <base-upload
            class="upload"
            :cover="params.img"
            :wSize="180"
            :hSize="90"
            :width="'180px'"
            :height="'90px'"
            @successCallback="handleAvatarSuccess"
          ></base-upload>
        </el-form-item>
        <el-form-item label="配置任务详情:" prop="desc">
          <el-button size="small" type="primary" @click="btnConfigDialog = true"
            >点击配置任务</el-button
          >
        </el-form-item>
        <el-form-item label="任务类型:" prop="type">
          <el-select
            v-model="params.type"
            size="small"
            placeholder="请选择任务类型"
            style="width: 300px"
          >
            <el-option
              v-for="item in types"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务模式:" prop="status">
          <el-select
            v-model="params.taskModel"
            size="small"
            placeholder="请选择任务模式"
            style="width: 300px"
          >
            <el-option :value="0" label="每日任务"></el-option>
            <el-option :value="1" label="一次性任务"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序:" prop="sortNum">
          <el-input
            v-model.number="params.sortNum"
            type="number"
            size="small"
            placeholder="请输入排序"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item label="跳转方式:" prop="hrefType">
          <el-select
            v-model.number="link_type"
            size="small"
            placeholder="跳转方式"
            style="width: 300px"
          >
            <el-option
              v-for="item in linkTypeList"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="链接地址" prop="link" v-if="link_type == 1">
          <el-input
            size="small"
            style="width: 300px"
            v-model.number="params.link"
          ></el-input>
        </el-form-item>
        <el-form-item label="链接地址:" prop="link" v-if="link_type == 2">
          <el-select
            v-model.number="params.link"
            size="small"
            placeholder="链接地址"
            filterable
            style="width: 300px"
          >
            <el-option
              v-for="item in linkList"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="视频ID" prop="videoId" v-if="isNeedId">
          <el-input
            size="small"
            style="width: 300px"
            v-model="videoId"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否启用:" prop="status">
          <el-select
            v-model="params.status"
            size="small"
            placeholder="请选择是否启用"
            style="width: 300px"
          >
            <el-option
              v-for="item in statusType"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          type="primary"
          size="small"
          @click="submitForm('form')"
          :loading="flag"
          >确 认</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="任务详情"
      :visible.sync="btnConfigDialog"
      width="800px"
      @before-close="btnConfigDialog = false"
    >
      <div
        v-for="(item, index) in details"
        :key="index"
        style="position: relative; margin-bottom: 20px"
      >
        <div v-if="details.length !== 0">
          <span style="margin: 10px 2px 10px 10px">奖品列表</span>
          <el-select
            v-model="details[index].prizes"
            size="small"
            placeholder="请选择任务奖励"
            style="width: 300px"
            multiple
            filterable
          >
            <el-option
              v-for="item in prizeBox"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
          <span style="margin: 10px 2px 10px 10px">达成条件</span>
          <el-input
            v-model.number="details[index].finishCondition"
            type="number"
            size="small"
            placeholder="请输入达成条件(连续签到多少天/活跃值)"
            style="width: 250px"
          ></el-input>
          <i
            class="el-icon-circle-plus"
            v-if="index === details.length - 1"
            style="
              color: #67c23a;
              font-size: 24px;
              cursor: pointer;
              position: absolute;
              right: 20px;
              top: 15px;
            "
            @click="addBtn"
          ></i>
          <i
            class="el-icon-remove"
            v-if="details.length > 1"
            style="
              color: #f56c6c;
              font-size: 24px;
              cursor: pointer;
              position: absolute;
              right: -5px;
              top: 15px;
            "
            @click="removeBtn(index)"
          ></i>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="btnConfigDialog = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
export default {
  props: {
    prizeBox: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      title: "",
      flag: false,
      id: "",
      dialogVisible: false,
      statusType: [
        {
          label: "启用",
          value: true,
        },
        {
          label: "禁用",
          value: false,
        },
      ],
      types: [
        {
          label: "每日广告点击",
          value: 0,
        },
        {
          label: "每日邀请",
          value: 1,
        },
        {
          label: "每日登录",
          value: 2,
        },
        {
          label: "每日评论",
          value: 3,
        },
        {
          label: "每日发布",
          value: 4,
        },

        {
          label: "购买vip",
          value: 5,
        },
        {
          label: "购买金币",
          value: 6,
        },
        {
          label: "绑定手机号",
          value: 7,
        },
        {
          label: "下载APP",
          value: 8,
        },
        {
          label: "神评",
          value: 9,
        },
        {
          label: "收藏",
          value: 10,
        },
      ],
      prices: [],
      params: {
        type: "",
        title: undefined,
        desc: undefined,
        status: false,
        img: "",
        link: "",
        detail: undefined,
        sortNum: 0,
      },
      linkTypeList: [
        { label: "外部浏览器跳转", value: 1 },
        { label: "内部浏览器跳转", value: 2 },
      ],
      link_type: 1,
      linkList: [
        { label: "客服", value: "yinseinner://kefu" },
        { label: "社区", value: "yinseinner://community_page" },
        { label: "推广", value: "yinseinner://universal_agent" },
        { label: "会员", value: "yinseinner://vip_page" },
        { label: "钱包", value: "yinseinner://wallet_page" },
        { label: "发布", value: "yinseinner://publish_page" },
        { label: "视频详情", value: "yinseinner://video?id=" },
        { label: "绑定手机", value: "yinseinner://init_bind_phone_page" },
        { label: "导航站", value: "yinseinner://navigation" },
      ],
      videoId: "",
      btnConfigDialog: false,
      details: [
        {
          prizes: [],
          finishCondition: undefined,
        },
      ],
    };
  },
  computed: {
    isInnerLink() {
      return this.link_type === 2;
    },
    isNeedId() {
      return this.isInnerLink && this.params.link.indexOf("?id=") > -1;
    },
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.title === "新增配置") {
            this.addContent();
            return;
          }
          if (this.title === "编辑配置") {
            this.editContent();
            return;
          }
        }
      });
    },
    // 增加数量
    addBtn() {
      this.details.push({
        prizes: [],
        finishCondition: undefined,
      });
    },
    // 减少数量
    removeBtn(indexOf) {
      this.details = this.details.filter((item, index) => {
        if (indexOf != index) {
          return item;
        }
      });
    },
    // 新增内容
    addContent() {
      let params = Object.assign({}, this.params, {
        finishCondition: Number(this.params.finishCondition),
      });
      if (this.details.length > 0 && this.details[0].prizes.length != 0) {
        params.detail = this.details;
      }
      if (this.isNeedId && !this.videoId) {
        this.$message({
          type: "error",
          message: "请输入视频ID",
        });
        return;
      }
      if (this.isNeedId) {
        params.link = params.link + this.videoId;
      }
      API.addDailyActivity(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "新增成功",
              type: "success",
            });
            this.$emit("handlerContent");
          } else {
            this.$message.error(res.msg || "新增失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 修改内容
    editContent() {
      let params = Object.assign({}, this.params, {
        finishCondition: Number(this.params.finishCondition),
      });
      if (this.details.length > 0 && this.details[0].prizes.length != 0) {
        params.detail = this.details;
      }
      if (this.isNeedId && !this.videoId) {
        this.$message({
          type: "error",
          message: "请输入视频ID",
        });
        return;
      }
      if (this.isNeedId) {
        params.link = params.link + this.videoId;
      }
      API.editDailyActive(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.$emit("handlerContent");
          } else {
            this.$message.error(res.msg || "修改失败");
          }
          this.flag = false;
          this.handleClose();
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 标签封面上传成功回掉
    handleAvatarSuccess(res) {
      this.params.img = res.data.coverImg;
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.flag = false;
      this.$refs.form.resetFields();
      this.params = {
        type: "",
        desc: undefined,
        title: undefined,
        status: false,
        img: "",
        link: "",
        detail: [],
        sortNum: 0,
      };
      this.details = [
        {
          prizes: [],
          finishCondition: undefined,
        },
      ];
    },
    open(type, data) {
      this.dialogVisible = true;
      if (type === "edit") {
        this.params = Object.assign({}, data);
        if (this.params.detail) {
          this.details = this.params.detail;
        }
        if (
          this.linkList.findIndex(
            (v) => this.params.link.indexOf(v.value) > -1
          ) > -1
        ) {
          this.link_type = 2;
        }
        if (this.params.link.indexOf("?id=") > -1) {
          const splitArr = this.params.link.split("=");
          this.params.link = splitArr[0] + "=";
          this.videoId = splitArr[1];
        } else {
          this.params.link = this.params.link;
        }
        this.title = "编辑配置";
      } else {
        this.title = "新增配置";
      }
    },
  },
};
</script>
<style scoped>
.el-input {
  width: 220px;
}
</style>
